@import './ui-cms-sticky-toolbar-item-standard';
/* stylelint-disable declaration-no-important */
:host {
  display: block;
  margin-left: calc(100% - 45px);

  .content {
    z-index: 99999;
    overflow-y: scroll;
  }

  ::slotted(div.mgnlEditorBar) {
    margin-top: 30px !important;
  }
}
